import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogRepository } from '../../core/domain/blog/repositories/blog.repository';
import { GetBlogsUseCase } from '@/core/domain/blog/usecases/getBlogs.usecase';
import { BlogImplRepository } from './blog-impl.repository';

const GetBlogsUseCaseFactory = (blogRepository: BlogRepository) =>
    new GetBlogsUseCase(blogRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetBlogsUseCase,
            useFactory: GetBlogsUseCaseFactory,
            deps: [BlogRepository],
        },
        {
            provide: BlogRepository,
            useClass: BlogImplRepository,
        },
    ],
})
export class BlogDataModule {}
